import * as hourConstants from 'constants/export';
import * as constants from 'constants/filters';
import { without } from 'lodash-es';

const hourToTableColumnMap: Partial<Record<hourConstants.HourColumn, constants.Column>> = {
  [hourConstants.COLUMN_HOUR_BILLED]: constants.COLUMN_BILLED,
  [hourConstants.COLUMN_HOUR_NOTE]: constants.COLUMN_NOTES,
  [hourConstants.COLUMN_HOUR_DATE]: constants.COLUMN_DATE,
  [hourConstants.COLUMN_HOUR_LABELS]: constants.COLUMN_TAGS,
} as const;

const tableToSortColumnMap = {
  [constants.COLUMN_DAY]: 'day',
  [constants.COLUMN_PROJECT]: 'project',
  [constants.COLUMN_LOGGED_HOURS]: 'total_minutes',
  [constants.COLUMN_LOGGED_MONEY]: 'cost',
  [constants.COLUMN_ESTIMATED_HOURS]: 'estimated_total_minutes',
  [constants.COLUMN_ESTIMATED_MONEY]: 'estimated_cost',
  [constants.COLUMN_BILLED]: 'billed',
  [constants.COLUMN_STATE]: 'state',
} as const;

export const mapHourColumnToTable = (hourColumn: string): string =>
  (hourToTableColumnMap as Record<string, string>)[hourColumn] ?? hourColumn;

export const mapTableColumnToSort = (tableColumn: string): string =>
  (tableToSortColumnMap as Record<string, string>)[tableColumn] ?? tableToSortColumnMap;

export const toggleExportColumn = <T extends hourConstants.HourColumn | hourConstants.TaskColumn>(
  column: T,
  columns: Array<T>,
  isChecked: boolean,
  callback: (columns: Array<T>) => unknown
) => {
  const updatedColumns = !isChecked ? without(columns, column) : [...columns, column];
  return callback(updatedColumns);
};
